import { Box, Button, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'

type Props = { defaultName: string; onConvert: (categoryName: string) => void }

const ConvertToCategoryAction: React.FC<Props> = ({ defaultName, onConvert }) => {
  const [categoryName, setCategoryName] = useState(defaultName)

  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        Make it a category instead
      </Typography>
      <Box display="flex" gap={1} mt={0.5}>
        <TextField
          size="small"
          fullWidth
          placeholder="Category name"
          value={categoryName}
          onChange={e => setCategoryName(e.target.value)}
        />
        <Button
          variant="outlined"
          size="small"
          disabled={!categoryName.trim()}
          onClick={() => onConvert(categoryName.trim())}
        >
          Convert
        </Button>
      </Box>
    </Box>
  )
}

export default ConvertToCategoryAction
